// src/RouteWrapper.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './component/front/header/Header';
import Footer from './component/front/header/Footer';

const RouteWrapper = ({ children, onSearchChange , trading , tradingTwo }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
      {!isAdminRoute && <Header onSearchChange={onSearchChange} trading={trading} tradingTwo={tradingTwo}/>}
      <main className="min-h-[calc(100vh-1px)] bg-slate-50 text-slate-900 transition-colors dark:bg-slate-950 dark:text-slate-100">
        {children}
      </main>
      {!isAdminRoute && <Footer />}
    </>
  );
};

export default RouteWrapper;
